import { Drawer } from "antd";
import { mediaQueryPoint, useMediaQuery } from "../../../../../utils/hooks";
import "./index.scss";
import BasePopup from "../Popup/index";
import bgHeaderTop from "../../../../../assets/images/Mini-Game/bg-header-popup-rule.png";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";

export default function PopupFooter({
  children,
  isOpen,
  onClose,
  className,
  isShowSrcImgHeader = true,
  srcImgHeader = "",
  isGetContainer = true,
}) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);

  return (
    <>
      {isMobile ? (
        <Drawer
          placement="bottom"
          open={isOpen}
          onClose={onClose}
          closeIcon={false}
          className={`drawer-container-popup drawer-popup-rule ${className || ""}`}
          height="auto"
          getContainer={isGetContainer ? "" : false}
          // modalRender={(node) => (
          //   <div style={{ display: "inline-block", width: "100%" }}>{node}</div>
          // )}
          style={{
            position: "fixed",
            bottom: "0",
            width: "100%",
            height: "auto",
            maxHeight: "calc(100vh - 160px)",
            zIndex: "99999", // optional
          }}
        >
          <div className="popup-minigame__2025__drawer">
            <div className="container-mini-popup">
              <img
                src={iconClosePopup}
                alt=""
                className="rule-mini-close"
                onClick={onClose}
              />
              {isShowSrcImgHeader ? (
                <img
                  src={srcImgHeader || bgHeaderTop}
                  alt=""
                  className="bg-rule-mini-top"
                />
              ) : null}
              <div className="mini-popup-main">{children}</div>
            </div>
          </div>
        </Drawer>
      ) : (
        <BasePopup
          open={isOpen}
          className={className}
          onCancel={onClose}
          getContainer
        >
          <div className="popup-minigame__2025">
            <div className="container-mini-popup">
              <img
                src={iconClosePopup}
                alt=""
                className="rule-mini-close"
                onClick={onClose}
              />
              {isShowSrcImgHeader ? (
                <img
                  src={srcImgHeader || bgHeaderTop}
                  alt=""
                  className="bg-rule-mini-top"
                />
              ) : null}

              {children}
            </div>
          </div>
        </BasePopup>
      )}
    </>
  );
}
